import React from "react";

import { Button } from "components";

import { ELEMENTS_IDS } from "constants/ElementsIds";

import styles from "./styles.module.scss";

interface Props {
  isButtonDisabled: boolean;
  onCancel: () => void;
  assignAnimalsToGroup: () => void;
  type: string;
}

export const EditModeButtons = ({ onCancel, isButtonDisabled, assignAnimalsToGroup, type }: Props): JSX.Element => (
  <div className={styles.viewButtons}>
    <Button
      id={ELEMENTS_IDS.GROUPS_EDIT_MODE_CANCEL_BUTTON}
      caption="Cancel"
      variant="hollow"
      colour="grey"
      onClick={onCancel}
      className={styles.groupActionButton}
    />
    <Button
      id={ELEMENTS_IDS.GROUPS_EDIT_MODE_ADD_TO_GROUP_BUTTON}
      disabled={isButtonDisabled}
      caption={`Add to ${type}`}
      onClick={assignAnimalsToGroup}
    />
  </div>
);
